










































import {
  defineComponent, computed,
} from '@vue/composition-api';
import { useQuery } from '@vue/apollo-composable';

import {
  NOW,
  NOW_START_YEAR,
  NOW_START_MONTH,
} from '@/utils';
import incomeStats from '@/gql/managementReport/01-Income/incomeStats.gql';

const IncomeStats = defineComponent({
  setup() {
    const { result: getTopInfo } = useQuery(incomeStats, computed(() => ({
      timeframe: { from: NOW_START_YEAR, to: NOW },
      timeframeMTD: { from: NOW_START_MONTH, to: NOW },
    })));
    const getPanelInfo = computed(() => getTopInfo.value?.incomeStats || []);
    const getPanelInfoMtd = computed(() => getTopInfo.value?.incomeStatsMTD || []);

    return {
      getPanelInfo,
      getPanelInfoMtd,
    };
  },
});

export default IncomeStats;
